/**
 * Dashboard Statistics Grid Component
 * - Displays key metrics in card format
 * - Shows active vets, bookings, revenue, and new users
 * - Includes trend indicators and comparisons
 */

import React from "react";
import { FaStethoscope, FaUserFriends } from "react-icons/fa";
import {  FiDollarSign, FiCalendar, } from "react-icons/fi";

const Tile = ({ icon, title, value, sub }) => (
  <div className="rounded-xl border border-gray-200 bg-white p-3 sm:p-4 lg:p-5 shadow-sm">
    <div className="flex items-start justify-between">
      <div className="text-sm sm:text-base lg:text-xl w-1/2 font-medium text-[#2B7FFC]">{title}</div>
      <div className="rounded-lg bg-blue-50 p-1.5 sm:p-2 text-blue-600">
        {React.cloneElement(icon, { className: "h-4 w-4 sm:h-5 sm:w-5" })}
      </div>
    </div>

    <div className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight tracking-tight text-gray-900">
      {value}
    </div>

    <div className="mt-1 text-[10px] sm:text-[11px] text-gray-400">{sub}</div>
  </div>
);

export default function StatsGrid({ dashboardData }) {
  const activeVets = dashboardData?.active_vets?.total ?? 0;
  const bookingsToday = dashboardData?.bookings?.today ?? 0;
  const newUsers = dashboardData?.new_users?.last_7_days ?? 0;

  // Calculate changes
  const vetsChange = dashboardData?.active_vets?.last_week !== undefined ? `+${dashboardData.active_vets.last_week} since last week` : 'N/A';
  const bookingsChange = dashboardData?.bookings?.last_week !== undefined ? `+${dashboardData.bookings.last_week} vs. yesterday` : 'N/A';
  const usersChange = dashboardData?.new_users?.last_week !== undefined ? `+${dashboardData.new_users.last_week} this week` : 'N/A';

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      <Tile
        icon={<FaStethoscope className="h-5 w-5" />}
        title="Active vets"
        value={activeVets}
        sub={vetsChange}
      />
      <Tile
        icon={<FiCalendar className="h-5 w-5" />}
        title="Bookings Today"
        value={bookingsToday}
        sub={bookingsChange}
      />
      <Tile
        icon={<FiDollarSign className="h-5 w-5" />}
        title="Revenue"
        value="N/A"
        sub="N/A"
      />
      <Tile
        icon={<FaUserFriends className="h-5 w-5" />}
        title="New Users"
        value={newUsers}
        sub={usersChange}
      />
    </div>
  );
}
